import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  '!CREATE_ATTACHMENT',
  '!DECREASE_ATTACHMENT',
  '!DOWNLOAD_ATTACHMENT',
  '!DOWNLOAD_EXPORT',
  '!FETCH_ATTACHMENTS',
  '!INCREASE_ATTACHMENT_COUNT',
  '!REMOVE_ATTACHMENT',
  '!UPDATE_ATTACHMENT_COUNT',
] as const

export default serviceActionsGenerator('attachment', actionTypes)
